export const environment_core = {
    webApiUrl: '#{AwsWebsite.AdminisApiUrl}',
    loginFeUrl: '#{AwsWebsite.LoginFeUrl}',
    loginApiUrl: '#{AwsWebsite.LoginApiUrl}',
    loginApiUrlBase: '#{LoginApi.BaseUrl}',
    loginApiCognitoUrl: '#{LoginApi.BaseUrl}/aws-cognito-auth/exchange-authorization',
    redirectUrlSso: '#{AwsWebsite.RedirectUrlSso}',

    /* Adding config names to this array allows the app to dynamically reskin via the URL
       At the moment we are not allowing that in production for anyone but it might be useful 
       in the future for specific clients or as the app changes a little 
       (eg. such as hosting an advisor portal and a client portal under the same domain
        or splitting kiwisaver and trading into separate configs but hosting under the same domain)
     */
    allowedUrlConfigs: []
};

/* Adding config names to this parameter allows the app to dynamically reskin via the URL
   This is only used in TEST and DEV environments at the moment which have a host of "my-... adminis.co.nz".
   That check is hard coded but would be nice to pull out and in the process also do a host -> config pair
   such that it worked in PROD as well for custom URLs instead of the current hard coded host check.
*/
export const urlConfigs = [
    'welcome',
    'rutherfordrede',
    'investnow',
    'investnowv2',
];